import {computed, Directive, effect, inject, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef} from '@angular/core';
import {PermissionService} from "@core/services/permission.service";

@Directive({
    standalone: true,
    selector: '[showWhenHasProfile]'
})
export class AppShowWhenHasProfileDirective implements OnInit, OnDestroy {
    private profiles: string[] = [];
    private logicalOp: 'OR' | 'AND' = 'OR';
    private isHidden = true;
    private profileSignal: any = null;

    private templateRef = inject(TemplateRef);
    private viewContainer = inject(ViewContainerRef);
    private permissionService = inject(PermissionService);

    constructor() {
        // Effect para reagir automaticamente a mudanças nos perfis
        effect(() => {
            if (this.profileSignal) {
                const hasAccess = this.profileSignal();
                this.updateView(hasAccess);
            }
        });
    }

    ngOnInit(): void {
        this.updateProfileSignal();
    }

    ngOnDestroy(): void {
        // Effect é automaticamente limpo quando o componente é destruído
    }

    @Input()
    set showWhenHasProfile(val: string[] | string) {
        this.profiles = Array.isArray(val) ? val : [val];
        this.updateProfileSignal();
    }

    @Input()
    set showWhenHasProfileOp(permOp: 'OR' | 'AND') {
        this.logicalOp = permOp;
        this.updateProfileSignal();
    }

    private updateProfileSignal(): void {
        // Se não há perfis especificados, sempre mostra
        if (!this.profiles || this.profiles.length === 0) {
            this.profileSignal = computed(() => true);
            return;
        }

        // Se é apenas um perfil, usa canAccess
        if (this.profiles.length === 1) {
            this.profileSignal = this.permissionService.canAccess(this.profiles[0]);
        }
        // Se são múltiplos perfis, usa o método apropriado
        else if (this.logicalOp === 'OR') {
            this.profileSignal = this.permissionService.canAccessAny(this.profiles);
        } else {
            this.profileSignal = this.permissionService.canAccessAll(this.profiles);
        }
    }

    private updateView(hasAccess: boolean): void {
        if (hasAccess && this.isHidden) {
            this.viewContainer.createEmbeddedView(this.templateRef);
            this.isHidden = false;
        } else if (!hasAccess && !this.isHidden) {
            this.viewContainer.clear();
            this.isHidden = true;
        }
    }
}
